import React from "react";

function SupportContact() {
  return React.createElement(
    "div",
    {
      className:
        "flex flex-col items-center justify-center h-screen bg-white text-center p-4 text-9xl leading-snug",
    },
    [
      "Dostęp został zablokowany. Skontaktuj się z ",
      React.createElement("strong", { key: "s" }, "support@bergregions.pl"),
    ]
  );
}

export default SupportContact;
